// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const postClickHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.facebook.post_click_history',
    tooltip: 'chart.facebook.tooltip_post_click_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.facebook.post_click_history_name'
    },
    id: 'post_clicks_history',
    social: FACEBOOK,
    color: {
        value: 'blue'
    },
    noLegend: true,
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
